<div [froalaView]="data | linky : { stripPrefix: false, newWindow: true }"></div>
